import Decimal from 'decimal.js'
import { QuoteType } from '@/lib/types'

type PaymentMilestonePercent = {
  dsy_percent: number | string | null | undefined
}

export function isPaymentMilestonePercentTotalValid(
  quoteType: QuoteType | number | undefined,
  milestones: PaymentMilestonePercent[]
) {
  // A cleared Percentage box holds '' until blur. Decimal throws on it, and a
  // blank is no allocation, so the schedule is invalid until it is filled.
  let total = new Decimal(0)
  for (const { dsy_percent } of milestones) {
    if (dsy_percent === '' || dsy_percent == null) return false
    total = total.add(dsy_percent)
  }

  if (quoteType === QuoteType.Budget) {
    return total.greaterThanOrEqualTo(0) && total.lessThanOrEqualTo(100)
  }

  return total.equals(100)
}

export function canRemovePaymentMilestone(quoteType: QuoteType | number | undefined, fieldsLength: number) {
  return quoteType === QuoteType.Budget || fieldsLength > 1
}

export function shouldUseDefaultPaymentMilestones(quoteType: QuoteType | number | undefined) {
  return quoteType !== QuoteType.Budget
}
